import axios from "axios";
import {InitPage} from "../index";

declare var $;
declare var App: any;
declare var messageDialogBox;
declare const tenantCode: string;
declare const readerGroupId: string;
declare const instanceClass: string;
declare const instanceId: string;
declare const loadingPathCheckStatusPath: string;
declare const logId: string;
declare var saveNotePath

class LoadingDocks {
    constructor() {
        $(document).on('input','#shipping_pb_shipment_log_note_message', function(){
            if($(this).val() != '')
                $('#error_message').text('')
        })
        $(document).on('click','#save_note',function(e) {
            e.preventDefault();
            // Prevent people from being trigger happy
            var message = $('#shipping_pb_shipment_log_note_message').val();
            if(message != '')
            {
                var important = $('#shipping_pb_shipment_log_note_important').is(':checked');
                var logId = $('#shipping_pb_shipment_log_note_pb_shipment_log_id').val();
                var userId = $('#shipping_pb_shipment_log_note_user_id').val();

                $.post(saveNotePath, { 'shipping_pb_shipment_log_note[message]': message, 'shipping_pb_shipment_log_note[important]': important, 'shipping_pb_shipment_log_note[pb_shipment_log_id]': logId, 'shipping_pb_shipment_log_note[user_id]': userId }).done(function(data) {
                    let content = "";
                    for (const note of data.log_notes) {
                        content += `
                        <tr class="center-content">
                            <td style="text-align: left !important">
                                <span class="hover-cursor-pointer" title="${note.message}" data-toggle="tooltip" data-placement="top">
                                ${note.truncated_message}
                                </span>
                            </td>`
                            if (note.important == true)
                                content += `
                                <td>
                                    <i class="fa fa-star text-red"></i>
                                </td>`
                            else
                                content += `
                                <td>
                                    <i class=""></i>
                                </td>`
                            content += `
                            <td>${note.user} <br/> ${note.created_at}</td>
                        </tr>`;
                    }

                    $(".note-table tbody").html(content);
                    $('#shipping_pb_shipment_log_note_message').val('');
                    $('#shipping_pb_shipment_log_note_important').prop('checked', false);
                    $('.note-icon[id='+logId+']').removeAttr('style');
                });
            }
            else
            {
                $('#error_message').text('Please fill out this field');
                $('#shipping_pb_shipment_log_note_message').focus();
            }
        });

    }
    init() {
        App.cable.subscriptions.create(
            {
              channel: "Shipping::LoadingDockChannel",
              tenant_code: tenantCode,
              reader_group_id: readerGroupId
            },
            {
              connected() {
                  console.log("Connected LoadingDockChannel");
               },
              disconnected() {
                console.log("Disconnected from LoadingDockChannel");
              },
              received(data: any) {
                $("#result").text(data.display_text);
                console.log(data);
                $(".pbList").each(function(index, element){
                  let palletSeen = $(element).text().trim();
                  if(data.pallets_seen.includes(parseInt(palletSeen)) || data.pallets_seen.includes(palletSeen)) {
                    $("#pb-" + palletSeen).hide();
                  } else {
                    $("#pb-" + palletSeen).show();
                  }
                });
                $("#endLoading").data("confirm", data.confirm_message);

                if (data.completed) {
                    $("#main").css("background", "#55efc4");
                    messageDialogBox("All Cartons / Pallets / Items seen");
                    $("#autoComplete")[0].click();
                } else if (data.over_limit) {
                    $("#main").css("background", "lightcoral");
                    messageDialogBox("30 minutes of no activity");
                    $("#autoClose")[0].click();
                } else if (data.pallets_fulfilled) {
                    $("#main").css("background", "#55efc4");
                    $("#endLoading").prop("style", "background-color:  #19641e");
                    $("#missing-pallets").prop("style", "background-color:  #19641e");
                    $("#missing-pallets").prop("style", "color:  darkblue");
                }

                if (data.create_or_update_alert) {
                    $("#seenWrongPallets").show();
                    let wp = "";
                    console.log(data.wrong_pallets);
                    data.wrong_pallets.forEach( item => {
                        wp = wp + item + ',';
                    });
                    $("#seenWrongPallets").html(`Wrong Pallets IDs: ${wp}`);
                    $("#palletIds").html(`${wp}`);
                    $("#assign_reason_modal").modal("show");
                    $("#shipping_pb_shipment_log_action_pb_pallet_ids").val(data.wrong_pallets);
                } else {
                    $("#assign_reason_modal").modal("hide");
                }
              }
            }
        );

        setInterval(this.refreshRequest, 15000);
    }

    refreshRequest() {
        axios.post(loadingPathCheckStatusPath, { tenant: tenantCode,
                                                 reader_group_id: readerGroupId,
                                                 instance_class: instanceClass,
                                                 instance_id: instanceId,
                                                 log_id: logId }
                  ).then((response) => { console.log(response); });
    }

}

export function LoadPage() {

    InitPage("loading_docks show", () => {
        $("#loadSearchResultDock").on("submit", (e) => {
            e.preventDefault();
            const searchUrl = $("#loadSearchResultDock").attr("action") + "?entity=" + $('input[name="entity"]:checked').val() + "&search_term=" + $("#search-term").val() + "&reader_group=" + $("#reader_group").val();
            $("#pin-auth-dialog #redirect_url").val(searchUrl);
            window.PinAuthentication.showPinLogin();
        });
    });

    InitPage("loading_docks search", () => {
        const loadingDocks = new LoadingDocks();
        loadingDocks.init();
    });

    InitPage("loading_docks logs", () => {
        const loadingDocks = new LoadingDocks();
    });
}
